import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/duanwu-festival/2026/Index.vue')
const Winners = () => import('../activity/duanwu-festival/2026/winners/Index.vue')
const ZongziFactory = () => import('../activity/duanwu-festival/2026/ZongziFactory.vue')
const LotteryRewards = () => import('../activity/duanwu-festival/2026/LotteryRewards.vue')
const ZongziMaterialRecords = () => import('../activity/duanwu-festival/2026/ZongziMaterialRecords.vue')
const Kitchen = () => import('../activity/duanwu-festival/2026/KitchenStealMaterialPage.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026',
  name: 'activity_duanwu_festival_2026',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '端午节活动',
  },
}

export const winnersRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026/winners',
  name: 'activity_duanwu_festival_2026_winners',
  component: Winners,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '端午节活动',
  },
}

export const zongziFactoryRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026/zongzi-factory',
  name: 'activity_duanwu_festival_2026_zongzi_factory',
  component: ZongziFactory,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '小队粽子制作',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026/lottery-rewards',
  name: 'activity_duanwu_festival_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export const zongziMaterialRecordsRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026/zongzi-material-records',
  name: 'activity_duanwu_festival_2026_zongzi_material_records',
  component: ZongziMaterialRecords,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '战队食材明细',
  },
}

export const kitchenStealMaterialRoute: RouteConfig = {
  path: '/activity/duanwu-festival/2026/kitchen',
  name: 'activity_duanwu_festival_2026_kitchen',
  component: Kitchen,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '厨房',
  },
}

export default [
  indexRoute,
  winnersRoute,
  zongziFactoryRoute,
  lotteryRewardsRoute,
  zongziMaterialRecordsRoute,
  kitchenStealMaterialRoute,
]
